// extracted by mini-css-extract-plugin
export default {"tabChildContainer":"QuestionFormModal_tabChildContainer__eeD9x"};